import { render, staticRenderFns } from "./BlockCount.vue?vue&type=template&id=e23f0918&scoped=true&"
import script from "./BlockCount.vue?vue&type=script&lang=js&"
export * from "./BlockCount.vue?vue&type=script&lang=js&"
import style0 from "./BlockCount.vue?vue&type=style&index=0&id=e23f0918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f0918",
  null
  
)

export default component.exports